/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-closing-bracket-location */
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { withTranslation } from 'react-i18next';
import { InputLabel, MenuItem, FormControl, Select, ListSubheader, FormHelperText } from '@material-ui/core';

import { amountFormate, formValidator } from '../../../AppUtil/AppUtil';
import { commonStyleForEditPersonalInfo } from '../../Common/CommonStyle';
import BaseForm from './BaseForm';
import { useMediaQuery } from 'react-responsive';
import { IIFC } from 'react-iifc';
import MobileFooter from '../../Common/Profile/MobileFooter';
import InputLabelMobile from '../../Common/Profile/InputLabelMobile';
import ExpandIcon from '../../Common/Profile/SvgIcon/ExpandIcon';
const { MOBILE } = window.AppConfig.SCREEN_SIZE;
class TopupForm extends React.Component {
	constructor(props) {
		super(props);
		this.inputLabel = React.createRef();
		this.state = {
			_disableSaveButton: true,
			_extras: { min: 50, max: 10000 },
			_editProfileForm: {
				amount: {
					value: '',
					placeholder: 'Amount',
					isValid: true,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'Amount is required'
						}
					},
					error_text: ''
				},
				description: {
					value: '',
					placeholder: 'Description',
					isValid: true,
					isTouched: false,
					error_text: '',
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'Description is required'
						}
					}
				},
				channel: {
					value: '',
					placeholder: 'Channel',
					isValid: true,
					isTouched: false,
					error_text: '',
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'Channel is required'
						}
					}
				}
			}
		};
	}

	handelInputChange = e => {
		this.setState({
			_disableSaveButton: false
		});
		const name = e.target.name;
		const value = e.target.value;
		const editProfileForm = {
			...this.state._editProfileForm
		};
		const updatedFormElement = {
			...editProfileForm[name]
		};
		updatedFormElement.value = value;
		updatedFormElement.isValid = true;
		updatedFormElement.error_text = '';
		editProfileForm[name] = updatedFormElement;
		this.setState({
			_editProfileForm: editProfileForm
		});
	};

	handleChannelChange = e => {
		const name = e.target.name;
		const value = e.target.value?.code;
		const extras = e.target.value?.extras;
		const editProfileForm = {
			...this.state._editProfileForm
		};
		const updatedFormElement = {
			...editProfileForm[name]
		};
		updatedFormElement.value = value;
		updatedFormElement.isValid = true;
		updatedFormElement.error_text = '';
		editProfileForm[name] = updatedFormElement;
		editProfileForm.amount.isValid = true;
		editProfileForm.amount.error_text = '';
		this.setState({
			_editProfileForm: editProfileForm,
			_disableSaveButton: false,
			_extras: extras
		});
	};

	onSubmitHandler = e => {
		e.preventDefault();
		if (!this.formValidator()) {
			return false;
		}
		const editProfileForm = {
			...this.state._editProfileForm
		};

		const userObj = {
			req_id: new Date().getTime(),
			amount: +editProfileForm.amount.value,
			note: editProfileForm.description.value,
			channel: editProfileForm.channel.value,
			recipient: this.props.user.email
		};
		this.props.onSubmit(userObj);
	};

	handleStateChange = (_event, value) => {
		const infoForm = {
			...this.state._editProfileForm
		};
		const updatedFormElement = {
			...infoForm.channel_code
		};
		updatedFormElement.value = value;
		updatedFormElement.isValid = true;
		updatedFormElement.error_text = '';
		infoForm.channel_code = updatedFormElement;
		this.setState({
			_editProfileForm: infoForm,
			_disableSaveButton: false
		});
	};

	formValidator = () => {
		const form = {
			...this.state._editProfileForm
		};
		let [updatedForm, isFormValid] = formValidator(form);
		const { _extras } = this.state;
		if (Number(updatedForm.amount.value) < _extras.min) {
			isFormValid = false;
			updatedForm.amount.isValid = false;
			updatedForm.amount.error_text = `Amount cannot be less than ${amountFormate(_extras.min)}`;
		}
		if (_extras.max !== 0 && Number(updatedForm.amount.value) > _extras.max) {
			isFormValid = false;
			updatedForm.amount.isValid = false;
			updatedForm.amount.error_text = `Amount cannot be more than ${amountFormate(_extras.max)}`;
		}
		this.setState({
			_editProfileForm: updatedForm
		});
		return isFormValid;
	};

	render() {
		const { classes, t, channelData, isLoading, closeProfileScreen } = this.props;
		const { _editProfileForm, _disableSaveButton } = this.state;

		const newValue = _editProfileForm.amount.value.toString().replace(/,/g, '');

		const finalValue = newValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

		return (
			<IIFC>
				{() => {
					const isMobile = useMediaQuery({ query: `(max-width: ${MOBILE})` });
					return (
						<>
							<BaseForm
								closeProfileScreen={closeProfileScreen}
								disabled={_disableSaveButton}
								isLoading={isLoading}
								onSubmitHandler={this.onSubmitHandler}>
								<Grid alignItems="center" item justify="center" sm={12} xs={12}>
									<Typography className="subtitle" component="h1" variant="h5">
										{t('profile.topup_details')}
									</Typography>
									{isMobile && (
										<p className="excluding_fees">
											Enter amount to top up excluding fees <br />{' '}
											<a
												style={{
													fontWeight: 'bold',
													fontSize: '10px',
													marginTop: '3px',
													display: 'inline-block',
													fontFamily: 'Raleway, sans-serif'
												}}
												rel="noopener"
												target="_blank"
												href="https://lendami.com.ph/faqs/">
												(Surcharge/Fees)
											</a>
										</p>
									)}
								</Grid>
								<Grid alignItems="center" item justify="center" sm={12} xs={12}>
									<InputLabelMobile label="Amount*" />
									<TextField
										autoComplete="amount"
										className={classes.displayFlex}
										error={!_editProfileForm.amount.isValid && _editProfileForm.amount.isTouched}
										fullWidth
										helperText={
											!_editProfileForm.amount.isValid && _editProfileForm.amount.isTouched
												? t(_editProfileForm.amount.error_text)
												: ''
										}
										id="amount"
										label={isMobile ? null : 'Amount'}
										placeholder={isMobile ? 'Amount' : null}
										name="amount"
										onChange={this.handelInputChange}
										required
										type="number"
										value={_editProfileForm.amount.value}
										variant="outlined"
									/>
								</Grid>
								<Grid alignItems="center" item justify="center" sm={12} xs={12}>
									<InputLabelMobile label="Description*" />
									<TextField
										autoComplete="description"
										className={classes.displayFlex}
										error={
											!_editProfileForm.description.isValid &&
											_editProfileForm.description.isTouched
										}
										fullWidth
										helperText={
											!_editProfileForm.description.isValid &&
											_editProfileForm.description.isTouched
												? t(_editProfileForm.description.error_text)
												: ''
										}
										id="description"
										label={isMobile ? null : 'Description'}
										name="description"
										onChange={this.handelInputChange}
										placeholder={isMobile ? 'Description' : null}
										required
										value={_editProfileForm.description.value}
										variant="outlined"
									/>
								</Grid>
								<Grid
									alignItems="center"
									item
									justify="center"
									className="topupfrom_grid"
									sm={12}
									xs={12}>
									<InputLabelMobile label="Channel*" />
									<FormControl fullWidth variant="outlined">
										{isMobile ? null : <InputLabel id="channel">Channel *</InputLabel>}

										<Select
											error={
												!_editProfileForm.channel.isValid && _editProfileForm.channel.isTouched
											}
											id="channel-select"
											displayEmpty
											name="channel"
											IconComponent={ExpandIcon}
											onChange={this.handleChannelChange}>
											{Object.keys(channelData).map((heading, index) => [
												<ListSubheader disableSticky key={index}>
													{heading}
												</ListSubheader>,

												Object.keys(channelData[heading]).map(channel => (
													<MenuItem key={channel} value={channelData[heading][channel]}>
														{channel}
													</MenuItem>
												))
											])}
										</Select>
										{!_editProfileForm.channel.isValid && _editProfileForm.channel.isTouched ? (
											<FormHelperText id="text-red">
												{_editProfileForm.channel.error_text}
											</FormHelperText>
										) : (
											''
										)}
									</FormControl>
								</Grid>
								{isMobile ? null : <p>Note* Amount to be paid, excluding fees (20 pesos for OTC)</p>}
								<MobileFooter
									className="mt-140"
									onClick={this.props.closeProfileScreen}
									hasNext={true}
									onSubmit={this.onSubmitHandler}
									disabled={_disableSaveButton}
								/>
							</BaseForm>
						</>
					);
				}}
			</IIFC>
		);
	}
}

export default withStyles(commonStyleForEditPersonalInfo)(withTranslation()(TopupForm));
